/* ------------ TABLE CONFIGURATION ------------ */

export interface QuestionnaireEortcQlq {
  position: number;
  question: string;
}

export const Q_EORTC_QLQ: QuestionnaireEortcQlq[] = [
  {
    position: 1, question: 'Ha difficoltà nel fare lavori faticosi, come portare\n' +
      'una borsa della spesa pesante o una valigia?',
  },
  {
    position: 2, question: 'Ha difficoltà nel fare una lunga passeggiata?',
  },
  {
    position: 3, question: 'Ha difficoltà nel fare una breve passeggiata fuori casa?',
  },
  {
    position: 4, question: 'Ha bisogno di stare a letto o su una sedia durante il giorno?',
  },
  {
    position: 5, question: 'Ha bisogno di aiuto per mangiare, vestirsi, lavarsi\n' +
      'o andare in bagno?',
  },
  {
    position: 6, question: 'Ha avuto limitazioni nel fare il Suo lavoro o i lavori di casa?',
  },
  {
    position: 7, question: 'Ha avuto limitazioni nel praticare i Suoi passatempi, hobby\n' +
      'o altre attività di divertimento o svago?',
  },
  {
    position: 8, question: 'Le è mancato il fiato?',
  },
  {
    position: 9, question: 'Ha avuto dolore?',
  },
  {
    position: 10, question: 'Ha avuto bisogno di riposo?',
  },
  {
    position: 11, question: 'Ha avuto difficoltà a dormire?',
  },
  {
    position: 12, question: 'Ha sentito debolezza?',
  },
  {
    position: 13, question: 'Le è mancato l\'appetito?',
  },
  {
    position: 14, question: 'Ha avuto un senso di nausea?',
  },
  {
    position: 15, question: 'Ha vomitato?',
  },
  {
    position: 16, question: 'Ha avuto problemi di stitichezza?',
  },
  {
    position: 17, question: 'Ha avuto problemi di diarrea?',
  },
  {
    position: 18, question: 'Ha sentito stanchezza?',
  },
  {
    position: 19, question: 'Il dolore ha interferito con le Sue attività quotidiane?',
  },
  {
    position: 20, question: 'Ha avuto difficoltà a concentrarsi su cose come\n' +
      'leggere un giornale o guardare la televisione?',
  },
  {
    position: 21, question: 'Si è sentito(a) teso(a)?',
  },
  {
    position: 22, question: 'Ha avuto preoccupazioni?',
  },
  {
    position: 23, question: 'Ha avuto manifestazioni di irritabilità?',
  },
  {
    position: 24, question: 'Ha avvertito uno stato di depressione?',
  },
  {
    position: 25, question: 'Ha avuto difficoltà a ricordare le cose?',
  },
  {
    position: 26, question: 'Le Sue condizioni fisiche o il Suo trattamento medico\n' +
      'hanno interferito con la Sua vita familiare?',
  },
  {
    position: 27, question: 'Le Sue condizioni fisiche o il Suo trattamento medico\n' +
      'hanno interferito con le Sue attività sociali?',
  },
  {
    position: 28, question: 'Le Sue condizioni fisiche o il Suo trattamento medico\n' +
      'Le hanno causato difficoltà finanziarie?',
  },
  {
    position: 29, question: 'Come valuterebbe in generale la Sua salute durante gli ultimi sette giorni?',
  },
  {
    position: 30, question: 'Come valuterebbe in generale la Sua qualità di vita durante gli ultimi sette giorni?',
  },
  {
    position: 31, question: 'Ha avuto difficoltà nel consumare cibi solidi?',
  },
  {
    position: 32, question: 'Ha avuto difficoltà nel consumare cibi liquidi o di consistenza molle?',
  },
  {
    position: 33, question: 'Ha avuto difficoltà nell’assumere liquidi?',
  },
  {
    position: 34, question: 'Ha provato una sensazione di disagio nel consumare un pasto?',
  },
  {
    position: 35, question: 'Ha provato dolore nella regione dello stomaco?',
  },
  {
    position: 36, question: 'Ha provato una sensazione di disagio nella regione dello stomaco?',
  },
  {
    position: 37, question: 'Ha avvertito una sensazione di gonfiore all’addome?',
  },
  {
    position: 38, question: 'Ha avuto risalita di acidità o bile in bocca?',
  },
  {
    position: 39, question: 'Ha avuto acidità o bruciore di stomaco?',
  },
  {
    position: 40, question: 'Le è capitato di eruttare?',
  },
  {
    position: 41, question: 'Ha provato una sensazione di sazietà precoce all’inizio del pasto?',
  },
  {
    position: 42, question: 'Ha avuto difficoltà nell’apprezzare I pasti?',
  },
  {
    position: 43, question: 'Consumare un pasto le ha richiesto molto tempo?',
  },
  {
    position: 44, question: 'Ha avuto secchezza alla bocca?',
  },
  {
    position: 45, question: 'Il cibo e le bevande avevano un sapore diverso dal solito?',
  },
  {
    position: 46, question: 'Consumare un pasto di fronte ad altri è stato causa di disagio?',
  },
  {
    position: 47, question: 'Le è capitato di pensare alla Sua malattia?',
  },
  {
    position: 48, question: 'Si è mai preoccupato(a) di pesare troppo poco?',
  },
  {
    position: 49, question: 'Si è sentito(a) fisicamente meno attraente come\n' +
      'conseguenza della Sua malattia o del trattamento?',
  },
  {
    position: 50, question: 'Il suo stato di salute futuro è stato fonte di preoccupazione?',
  },
  {
    position: 51, question: 'Ha perso capelli?',
  },
  {
    position: 52, question: 'Risponda solo se ha perso dei capelli:\n' +
      'La caduta dei capelli l’ha turbata?',
  }
];


export class EortcQlqResults {
  patientSSN: string;
  doctorID: string;
  results: number[];

  constructor(doctorID: string, patientSSN: string, results: number[]) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
  }

}
